/**
 * @module actions/customers
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

export function searchDracarCustomer (data) {
  const url = API_URL + '/Dracar/Search/Customer'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function searchDracarCompany (data) {
  const url = API_URL + '/Dracar/Search/Company'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function searchDracarVehicle (data) {
  const url = API_URL + '/Dracar/Search/Vehicle'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function checkForDracarVehicle (data) {
  const url = API_URL + '/Dracar/Search/CheckVehicle'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function validateOrder (data) {
  const url = API_URL + '/Dracar/Validate/Order'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function validateDracarCustomer (data) {
  const url = API_URL + '/Dracar/Validate/Customer'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function validateDracarVehicle (data) {
  const url = API_URL + '/Dracar/Validate/Vehicle'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function createDracarRepairOrder (data) {
  const url = API_URL + '/Dracar/Create/RepairOrder'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function getDracarRepairOrder (data) {
  const url = API_URL + '/Dracar/RepairOrder/Get'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function checkVehicleForCustomers (data) {
  const url = API_URL + '/Dracar/VehicleCustomers'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/dracar.js